import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { Line } from 'vue-chartjs';
import { Chart, registerables } from 'chart.js';
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import { getLegend, getTooltip } from "@/util/chartOptions";
import dayjs from "dayjs";
let DashBoardLineChart = class DashBoardLineChart extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "graphs", void 0);
    _defineProperty(this, "legendTooltipId", void 0);
    _defineProperty(this, "title", void 0);
    _defineProperty(this, "cumulative", void 0);
    _defineProperty(this, "datasets", []);
    _defineProperty(this, "startDates", []);
    _defineProperty(this, "endDates", []);
    _defineProperty(this, "legends", []);
    _defineProperty(this, "loading", false);
  }
  mounted() {
    Chart.register(...registerables);
    setTimeout(() => {
      this.loading = true;
    }, 10);
  }
  onDataChange() {
    if (this.graphs) {
      this.startDates = this.graphs[0].data.map(d => {
        return dayjs(d.startDate).format(this.$t('formatDateDayMonth').toString());
      });
      this.endDates = this.graphs[0].data.map(d => {
        return dayjs(d.endDate).format(this.$t('formatDateDayMonth').toString());
      });
      this.datasets = this.graphs.map(g => {
        return {
          label: g.legend,
          fill: true,
          tension: 0,
          backgroundColor: this.getDegrade(g.rgbaColor),
          borderColor: g.rgbaColor,
          pointBorderColor: g.rgbaColor,
          pointBackgroundColor: g.rgbaColor,
          borderWidth: 2,
          xAxis: this.startDates,
          pointBorderWidth: 2,
          data: g.data.map(d => {
            return d.value;
          }),
          tooltipFirstPeriodDates: this.startDates,
          tooltipSecondPeriodDates: this.endDates
        };
      });
      this.legends = this.graphs.map(g => g.tooltipLegend);
    }
  }
  getDegrade(rgba) {
    return context => {
      const {
        chart
      } = context;
      const {
        ctx,
        chartArea
      } = chart;
      if (!chartArea) {
        return rgba;
      }
      const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
      gradient.addColorStop(0, "rgb(221,221,246)");
      gradient.addColorStop(1, "rgba(255,255,255,0)");
      return gradient;
    };
  }
  get dataGraph() {
    return {
      labels: this.endDates,
      datasets: this.datasets
    };
  }
  get options() {
    return {
      plugins: {
        legend: getLegend(this.legends, this.legendTooltipId),
        tooltip: getTooltip("nearest", this.title, this.$t, this.cumulative)
      },
      scales: {
        x: {
          grid: {
            drawOnChartArea: false,
            drawBorder: false,
            display: false
          }
        },
        y: {
          grid: {
            drawBorder: false
          },
          beginAtZero: true,
          ticks: {
            callback: value => {
              if (value % 2 === 0) {
                return value;
              } else {
                return null;
              }
            }
          }
        }
      }
    };
  }
};
__decorate([Prop({
  required: true
})], DashBoardLineChart.prototype, "graphs", void 0);
__decorate([Prop({
  default: ""
})], DashBoardLineChart.prototype, "legendTooltipId", void 0);
__decorate([Prop({
  default: ""
})], DashBoardLineChart.prototype, "title", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], DashBoardLineChart.prototype, "cumulative", void 0);
__decorate([Watch("graphs")], DashBoardLineChart.prototype, "onDataChange", null);
DashBoardLineChart = __decorate([Component({
  components: {
    Line
  }
})], DashBoardLineChart);
export default DashBoardLineChart;